document.addEventListener('DOMContentLoaded', function() {
  // Set up subscription buttons
  setupSubscriptionButtons();

  togglePricingPeriod();
  
  // Toggle between monthly and yearly pricing
  const pricingToggle = document.querySelector('.pricing-toggle');
  if (pricingToggle) {
    pricingToggle.addEventListener('click', function() {
      togglePricingPeriod();
    });
  }
});

function setupSubscriptionButtons() {
  const planCards = document.querySelectorAll('.pricing-card');

  planCards.forEach(card => {
    const stripeButton = card.querySelector('.stripe-subscription-button');
    if (stripeButton) {
      const productId = stripeButton.dataset.productId;
      console.log('Found product ID:', productId);

      const subscribeBtn = document.createElement('button');
      subscribeBtn.className = 'subscribe-btn';

      const planTitle = card.querySelector('h3').textContent;
      const isFree = planTitle.includes('Freemium');
      const isEnterprise = planTitle.includes('Enterprise');
      subscribeBtn.textContent = isFree ? 'Sign Up Free' : isEnterprise ? 'Contact Us' : 'Start 7-Day Free Trial';

      subscribeBtn.addEventListener('click', function(e) {
        e.preventDefault();

        if (isEnterprise) {
          window.location.href = 'https://info.r1learning.com/r1-discover-enterprise'; // Redirect to a contact page
          return;
        }

        // Title -> API plan mapping. The API expects plan ∈ freemium|basic|professional.
        // New card lineup is "Basic" / "Pro" / "Enterprise" (Freemium removed from the UI).
        // A card titled "Pro" must map to the API string "professional" — the original
        // includes('Professional') check would miss "Pro" and fall through to freemium,
        // so map explicitly: Basic -> basic, Pro/Professional -> professional.
        const plan = planTitle.includes('Basic') ? 'basic'
          : (planTitle.includes('Pro') || planTitle.includes('Professional')) ? 'professional'
          : 'freemium';
        const pricingToggle = document.querySelector('.pricing-toggle');
        const billingInterval = pricingToggle.classList.contains('yearly') ? 'yearly' : 'monthly';
        const quantity = plan === 'business' ? prompt('Enter number of licenses (1-100):', '1') || 1 : 1;

        fetchCheckoutToken(plan, billingInterval, quantity);
      });

      stripeButton.parentNode.insertBefore(subscribeBtn, stripeButton);
      stripeButton.style.display = 'none';
    }
  });
}

function fetchCheckoutToken(plan, billingInterval, quantity) {
  fetch('https://api.r1learning.com/subscription/stripe/checkout/token', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include', // Send cookies
  })
  .then(response => {
    return response.text(); // Get raw text instead of json() for debugging
  })
  .then(rawText => {
    const data = JSON.parse(rawText); // Attempt to parse it manually
    if (data.error) {
      alert('Error fetching token: ' + data.error);
      return;
    }
    redirectToStripeCheckout(plan, billingInterval, quantity, data.token, data.timestamp, data.csrf_token);
  })
  .catch(error => {
    console.error('Error fetching checkout token:', error);
    alert('Error initializing checkout');
  });
}

function redirectToStripeCheckout(plan, billingInterval, quantity, token, timestamp, csrfToken) {
  const loadingOverlay = document.createElement('div');
  loadingOverlay.className = 'loading-overlay';
  loadingOverlay.innerHTML = '<div class="spinner"></div>';
  document.body.appendChild(loadingOverlay);

  fetch('https://api.r1learning.com/subscription/stripe/checkout', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Checkout-Timestamp': timestamp,
      'X-Checkout-Token': token,
      'X-CSRF-Token': csrfToken,
    },
    credentials: 'include', // Send cookies
    body: JSON.stringify({
      plan: plan,
      billing_interval: billingInterval,
      quantity: parseInt(quantity),
    }),
  })
  .then(response => response.json())
  .then(data => {
    document.body.removeChild(loadingOverlay);

    if (data.error) {
      alert('Error: ' + data.error);
      return;
    }

    window.location.href = data.url; // Redirect to Stripe Checkout
  })
  .catch(error => {
    document.body.removeChild(loadingOverlay);
    alert('Error redirecting to checkout: ' + error.message);
  });
}

function togglePricingPeriod() {
  const toggle = document.querySelector('.pricing-toggle');
  const toggleBtn = toggle.querySelector('.toggle-btn');
  const isYearly = toggle.classList.toggle('yearly');

  if (isYearly) {
    toggleBtn.classList.add('active'); // Fixed: classList
  } else {
    toggleBtn.classList.remove('active'); // Fixed: classList
  }
  
  // Update all price elements
  document.querySelectorAll('.price, .table-price').forEach(priceEl => {
    if (priceEl.dataset.monthly && priceEl.dataset.yearly) {
      const monthlyPrice = priceEl.dataset.monthly;
      const yearlyPrice = priceEl.dataset.yearly;
      priceEl.textContent = isYearly ? yearlyPrice : monthlyPrice;
    }
  });
  
  // Update all period elements
  document.querySelectorAll('.price-period, .table-price-period').forEach(periodEl => {
    if (periodEl.dataset.monthly && periodEl.dataset.yearly) {
      const monthlyPeriod = periodEl.dataset.monthly;
      const yearlyPeriod = periodEl.dataset.yearly;
      periodEl.textContent = isYearly ? yearlyPeriod : monthlyPeriod;
    }
  });
}